// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-top-forwards-module__wrapper--31QYW{padding:20px 0 80px}.widget-top-forwards-module__title--3ZXv6{color:#fff;font-size:24px;line-height:1.04;font-weight:700;letter-spacing:-.03em;margin-bottom:20px}@media screen and (min-width:1152px){.widget-top-forwards-module__title--3ZXv6{font-size:32px;line-height:1.09;font-weight:700;letter-spacing:-.03em;margin-bottom:30px}}.widget-top-forwards-module__placeholder--3rdbE{padding:25px;background:#fff;border-radius:6px;color:#000;font-weight:400;font-size:16px;line-height:20px}@media screen and (min-width:1152px){.widget-top-forwards-module__placeholder--3rdbE{padding:30px 35px}}", ""]);
// Exports
exports.locals = {
	"wrapper": "widget-top-forwards-module__wrapper--31QYW",
	"title": "widget-top-forwards-module__title--3ZXv6",
	"placeholder": "widget-top-forwards-module__placeholder--3rdbE"
};
module.exports = exports;
